import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { teaserContentTypes } from 'appConstants';
import { Select } from 'antd';
import { TeasersContext, ITeasersContext } from 'modules/Teasers/Teasers/teasersState/teasersContext';
import { useTranslation } from 'react-i18next';
import style from './ContentTypeSelect.module.scss';

const { Option } = Select;

const ContentTypeSelect: React.FC = () => {
	const { setIDContentType, IDSelectedContentType } = useContext<ITeasersContext>(TeasersContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { t } = useTranslation('listing');

	return (
		<div className={style.container} data-test="ContentTypeSelect">
			<Text translationNameSpace="listing" translationKey="contentTypeLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDContentType}
				value={IDSelectedContentType}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				listItemHeight={teaserContentTypes.length}
				allowClear={true}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				<>
					<Option className={style.disabledItem} value="empty" disabled={true}>
						<Text
							translationNameSpace="listing"
							translationKey="selectAnyItemPlaceholder"
							asFragment={true}
						/>
					</Option>
					{teaserContentTypes.map((el) => (
						<Option className={style.listItem} value={el.id} key={el.id}>
							<Text translationNameSpace="listing" translationKey={el.name} asFragment={true} />
						</Option>
					))}
				</>
			</Select>
		</div>
	);
};

export default ContentTypeSelect;
